import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiTheme } from '../components/Styles'

const TemplateWrapper = ({ children }) => {
  // const { prismicDocument } = data;
  return (
    <MuiThemeProvider theme={MuiTheme}>
      <Helmet
        titleTemplate={`%s – AirFly`}
        title="Ecole de parapenthe à Mauborget">
          <meta name="description" content="Sample" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
          <meta name="msapplication-TileColor" content="#da532c" />
          <meta name="theme-color" content="#ffffff" />
        </Helmet>
      {children()}
    </MuiThemeProvider>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper


// WEBPACK FOOTER //
// ./src/layouts/index.js